import React from 'react';
import { Heart } from 'lucide-react';
export function WhoItsFor() {
  return <section className="py-20 bg-[#E8F0EC]" data-id="element-165">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-166">
        <div className="bg-[#1B5E5E] rounded-[2.5rem] p-8 md:p-16 text-white text-center shadow-2xl relative overflow-hidden" data-id="element-167">
          {/* Decorative circles */}
          <div className="absolute top-0 left-0 w-64 h-64 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2" data-id="element-168" />
          <div className="absolute bottom-0 right-0 w-64 h-64 bg-[#C9A84C]/10 rounded-full translate-x-1/3 translate-y-1/3" data-id="element-169" />

          <div className="relative z-10" data-id="element-170">
            <Heart className="w-16 h-16 text-[#C9A84C] mx-auto mb-8" data-id="element-171" />
            <h2 className="text-3xl md:text-4xl font-bold mb-12 text-white" data-id="element-172">
              Este Programa Es Exclusivamente Para:
            </h2>

            <div className="space-y-6 text-left max-w-2xl mx-auto" data-id="element-173">
              <div className="flex items-start gap-4 bg-white/10 p-6 rounded-2xl backdrop-blur-sm" data-id="element-174">
                <div className="bg-[#C9A84C] text-[#1B5E5E] rounded-full w-8 h-8 flex items-center justify-center font-bold flex-shrink-0 mt-1" data-id="element-175">
                  1
                </div>
                <p className="text-xl md:text-2xl font-medium" data-id="element-176">
                  Mujeres de +65 años que sienten rigidez al despertar y miedo a
                  perder su independencia.
                </p>
              </div>

              <div className="flex items-start gap-4 bg-white/10 p-6 rounded-2xl backdrop-blur-sm" data-id="element-177">
                <div className="bg-[#C9A84C] text-[#1B5E5E] rounded-full w-8 h-8 flex items-center justify-center font-bold flex-shrink-0 mt-1" data-id="element-178">
                  2
                </div>
                <p className="text-xl md:text-2xl font-medium" data-id="element-179">
                  Hispanas viviendo en USA que quieren evitar cirugías costosas
                  y recuperar su movilidad natural.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}